import { Component } from '@angular/core'

@Component({
  selector: 'se-po-persona-image-modal-docs',
  templateUrl: './persona-image-modal-docs.component.html',
  styleUrls: ['./persona-image-modal-docs.component.scss'],
  standalone: false,
})
export class PersonaImageModalDocsComponent {
}
